export const EVENT_TRACKING = {
  ALLOCATION_SUGGESTED: "Allocation suggested",
  GUIDED_TOUR_STARTED: "Guided tour started",
  GUIDED_TOUR_COMPLETED: "Guided tour completed",
  GUIDED_TOUR_SKIPPED: "Guided tour skipped",
  PERSON_CONTACTED: "Person contacted",
  SEARCH_FILTERED: "Search filtered",
  SEARCH_VIEWED: "Search viewed",
  SEARCH_QUERY: "Search query",
  // New-model explore_organisation events (dual-emit alongside legacy above)
  SEARCH_RESULTS_VIEWED: "Search Results Viewed",
  SEARCH_FILTER_COMPLETED: "Search Filter Completed",
  SEARCH_RESULT_COMPLETED: "Search Result Completed",
  TAG_NAVIGATION_COMPLETED: "Tag Navigation Completed",
  // MS-1182. Grammar names; homeAnalytics.ts function names keep the ticket ids.
  HOME_VIEWED: "Home Viewed",
  HOME_MODULE_VIEWED: "Home Module Viewed",
  HOME_MODULE_COMPLETED: "Home Module Completed",
  HOME_ACTION_STARTED: "Home Action Started",
  HOME_ACTION_COMPLETED: "Home Action Completed",
  HOME_ACTION_FAILED: "Home Action Failed",
  HOME_ACTION_UNDO_COMPLETED: "Home Action Undo Completed",
  HOME_ITEM_SNOOZE_COMPLETED: "Home Item Snooze Completed",
  HOME_VERSION_SWITCH_COMPLETED: "Home Version Switch Completed",
  SETTING_CHANGED: "Setting changed",
  INSIGHTS_CLICKED: "Insights clicked", // Insight Navigation
  INSIGHT_INTERACTION: "Insights interaction",
  TEAM_CLICKED: "Team clicked",
  TEAM_CREATED: "Team created",
  TEAM_REMOVED: "Team removed",
  TEAM_UPDATED: "Team updated",
  TEAM_MOVED: "Team moved",
  TEAM_MOVE_STARTED: "Team move started",
  PERSON_UPDATED: "Person updated",
  TAG_CLICKED: "Tag clicked",
  CHANGELOG_VIEWED: "Changelog viewed",
  CHANGELOG_EXPANDED: "Changelog expanded",
  CHANGELOG_VIEW_CHANGED: "Changelog view changed",
  CHANGELOG_EXPORT_STARTED: "Changelog export started",
  CHANGELOG_EXPORT_READY: "Changelog export ready",
  CHANGELOG_EXPORT_DOWNLOADED: "Changelog export downloaded",
  USER_ERROR: "User error",
  USER_FEEDBACK: "User feedback",
  USER_INVITED: "User invited",
  USER_INVITE_STARTED: "User invite started",
  USER_LOGOUT: "User logout",
  URL_CLICKED: "URL clicked",
  WORKSPACE_SWITCHED: "Workspace switched",
  TAG_UPDATED: "Tag updated",
};

export const EVENT_LOCATIONS = {
  TEAM_PAGE: "Team Page",
  TAG_PAGE: "Tag Details Page",
  NAV_BAR: "Nav Bar",
  PEOPLE_PAGE: "People Page",
  INSIGHT_PAGE: "Insight Page",
};

export const INSIGHT_INTERACTION = {
  PEOPLE_CSV_DOWNLOAD: "People CSV Downloaded",
  TAG_TYPE_BAR: "Tag Type Bar Clicked",
  CHILD_TEAM_CLICKED: "Child team explored",
  ALLOCATION_INSIGHT_EXPAND: "Expand Allocations",
  ALLOCATION_PERSON_DETAILS: "Navigate Person Details",
  ALLOCATION_PERSON_ALLOCATION: "Navigate Person Allocations",
};
